export default __webpack_public_path__ + "static/media/Gellix-LightItalic.ecf9f5a4.woff2";